import { Link, useParams, useSearchParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { user } from "../../routes/route";
import { IconButton, Paper, useScrollTrigger } from "@mui/material";
import profile from "../../Assests/image/profile_not_found.png";
import CommonListing from "../../components/commonListing/CommonListing";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Fragment, useEffect, useState } from "react";
// import RemedyTable from './viewTable/RemedyTable'
// import ConsultantHistoryTable from './viewTable/ConsultantHistoryTable'
import ModalBox from "../../components/modal/ModalBox";
import { getSelectedUserDetail, getUserHistoryApi } from "../../services/userManagement";
import scrollToUp from "../../utils/scrollToUp";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";
import { dateFormat } from "../../utils/dateFormat";
// import UserStatus from '../userManagement/UserStatus'
import { CapitalizeFirstWord } from "../../utils/CapitalizeFirstWord";
import consultantPerformance from "../../Assests/image/consultantPerformance.svg";
import ResponsiveDetailPage from "../../components/ResponsiveDetailPage";
import ResponsiveProfileSection from "../../components/ResponsiveProfileSection";
import ConsultantProfileSection from "../../components/ConsultantProfileSection";
import ResponsiveWalletSection from "../../components/ResponsiveWalletSection";
import ResponsiveTabs from "../../components/ResponsiveTabs";
import useResponsive from "../../hooks/useResponsive";


import {
  fetchWalletAdditionApi,
  fetchWalletDeductionApi,
  getConsultantOrderHistoryApi,
  getConsultantWaitlist,
  getSelectedConsultantDetail,
  goLiveApi,
  markGreenTickApi,
  sendWarningApi,
  updateHighPriorityStatusApi,
  updateCanEndTheCallStatusApi,
  addConsultantBankDetailsApi,
  getConsultantBankDetailsApi,
  addReviewByAdminApi,
} from "../../services/consultantManagement";
import Switch from "../../components/Switch/Switch";
import ConsultantHistory from "./ViewConsultantHistory/ConsultantHistory";
import ConsultantReviewsListing from "./ConsultantReviewsListing";
import { fatchCategoryApi } from "../../services/categoryManagement";
import { Input, TextArea } from "../../components/Form";
import {
  allowAlphaNumericWithSpace,
  allowNumber,
  optimizeFunction,
} from "../../utils/regex";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { useNavigate } from "react-router-dom";
import WaitListModal from "../../components/modal/WaitListModal";
import DashboardAnalytics from "./DashboardAnalytics";
import ConsultantOnlineSchedule from "./ConsultantOnlineSchedule";
import ConsultantOnlineTime from "./ConsultantOnlineTime";
import ConsultantTransactionListing from "./ConsultantTransactionListing";
import ConsultantQueriesListing from "./ConsultantQueriesListing";
import Loader from "../../comman/Loader";
import { Box } from "@mui/material";
import { CustomTabs, CustomTab } from "../../components/tabs/Tabs";
import useDebounce from "../../hooks/useDebounce";
import { IoSearch } from "react-icons/io5";
const { USER_MANAGEMENT } = user;

const tabData = [
  {
    id: 1,
    title: "Remedy",
    eventKey: "remedy",
  },
  {
    id: 2,
    title: "Consultant History",
    eventKey: "consultant",
  },
  {
    id: 3,
    title: "Transaction",
    eventKey: "transaction",
  },
];

const formatDetailValue = (value) => {
  if (value === null || value === undefined || value === "") return "---";
  if (Array.isArray(value)) return value.length ? value.filter(Boolean).join(", ") || "---" : "---";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

const ConsultantDetail = () => {
  const navigate = useNavigate();
  const { id: consultantId } = useParams();
  const { isMobile, isTablet } = useResponsive();
  const [searchParam, setSearchParam] = useSearchParams();
  const fromSource = searchParam.get("from") || ""; // "management" = from Consultant Management tab, "activity" = from Consultant Activity tab
  // Tab state: 0 = Consultant Management, 1 = Consultant Activity — when from=activity open on Activity only
  const [activeSectionTab, setActiveSectionTab] = useState(() =>
    typeof window !== "undefined" && new URLSearchParams(window.location.search).get("from") === "activity" ? 1 : 0
  );
  let activePage = +searchParam.get("page") || 1;
  let type = searchParam.get("type") || "consultant";
  const [consultantDetail, setConsultantDetail] = useState("");
  const [consultantGoLive, setConsultantGoLive] = useState(null);
  const [consultantEducationDetail, setConsultantEducationDetail] = useState(
    ""
  );
  const [key, setKey] = useState("remedy");
  const [blockUserModel, setBlockUserModel] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [statusId, setStatusId] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [skillList, setSkillList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [buttonref, buttonLoader] = useButtonLoader("Send");
  const [warningField, setWarningField] = useState({});
  const [error, setError] = useState({});
  const [orderList, setOrderList] = useState([]);
  const [waitList, setWaitList] = useState([]);
  const [total, setTotal] = useState(null);
  const [totalWaitlist, setTotalWaitlist] = useState(null)
  const [deductionValue, setDeducationValue] = useState("");
  const [deductionModal, setDeductionModal] = useState(false);
  const [deductionError, setDeductionError] = useState("");
  const [AddDeductState, setAddDeductState] = useState(0); // 0: Deduction, 1:Addition
  const [WaitlistModal, setWaitlistModal] = useState(false)
  const [greenTickMOdal, setGreenTickModal] = useState(false);
  const [consultantGreenTick, setConsultantGreenTick] = useState(null);
  const [goLiveModal, setGoLiveModal] = useState(false);
  const [highPriorityModal, setHighPriorityModal] = useState(false);
  const [consultantHighPriority, setConsultantHighPriority] = useState(null);
  const [canEndTheCallModal, setCanEndTheCallModal] = useState(false);
  const [consultantCanEndTheCall, setConsultantCanEndTheCall] = useState(null);
  const [bankDetailsModal, setBankDetailsModal] = useState(false);
  const [bankFormData, setBankFormData] = useState({});
  const [bankImageFiles, setBankImageFiles] = useState({});
  const [bankImagePreviews, setBankImagePreviews] = useState({});
  const [bankButtonref, bankButtonLoader] = useButtonLoader("Save");
  const [existingBankDetails, setExistingBankDetails] = useState(null);
  const [isLoadingBankDetails, setIsLoadingBankDetails] = useState(false);
  const [panCardModal, setPanCardModal] = useState(false);
  const [panFormData, setPanFormData] = useState({});
  const [panImageFile, setPanImageFile] = useState(null);
  const [panImagePreview, setPanImagePreview] = useState("");
  const [panButtonref, panButtonLoader] = useButtonLoader("Save");
  const [existingPanDetails, setExistingPanDetails] = useState(null);
  const [isLoadingPanDetails, setIsLoadingPanDetails] = useState(false);
  const searchParams = useSearchParams();

  // Search states for Consultation History, Transaction, Reviews
  const [searchHistory, setSearchHistory] = useState("");
  const [searchTransaction, setSearchTransaction] = useState("");
  const [searchReviews, setSearchReviews] = useState("");
  const [searchQueries, setSearchQueries] = useState("");
  const debouncedSearchHistory = useDebounce(searchHistory, 300);
  const debouncedSearchTransaction = useDebounce(searchTransaction, 300);
  const debouncedSearchReviews = useDebounce(searchReviews, 300);
  const debouncedSearchQueries = useDebounce(searchQueries, 300);

  // Date range filter for Reviews
  const [reviewStartDate, setReviewStartDate] = useState("");
  const [reviewEndDate, setReviewEndDate] = useState("");

  // Date range filter for Transaction
  const [transactionStartDate, setTransactionStartDate] = useState("");
  const [transactionEndDate, setTransactionEndDate] = useState("");

  const [queryStartDate, setQueryStartDate] = useState("");
  const [queryEndDate, setQueryEndDate] = useState("");

  // Date range filter for Consultation History
  const [historyStartDate, setHistoryStartDate] = useState("");
  const [historyEndDate, setHistoryEndDate] = useState("");
  // Dropdown filters for Consultation History
  const [historyGender, setHistoryGender] = useState("");
  const [historyConsultationType, setHistoryConsultationType] = useState("");
  const [historyUserProblem, setHistoryUserProblem] = useState("");
  const [historyStatus, setHistoryStatus] = useState("");
  const [historyConsultationOrder, setHistoryConsultationOrder] = useState("");
  const [historyUserTotalConsultations, setHistoryUserTotalConsultations] = useState("");

  // Review modal states
  const [reviewModal, setReviewModal] = useState(false);
  const [reviewFormData, setReviewFormData] = useState({
    review: "",
    rating: 5,
    userName: "",
    customDate: "",
    customTime: "",
    ratingType: "chat",
    reply: ""
  });
  const [reviewUserImage, setReviewUserImage] = useState(null);
  const [reviewUserImagePreview, setReviewUserImagePreview] = useState("");
  const [reviewError, setReviewError] = useState({});
  const [reviewButtonref, reviewButtonLoader] = useButtonLoader("Add Review");
  const [aboutMeModal, setAboutMeModal] = useState(false);

  const toggleSelectBox = () => {
    setIsOpen(!isOpen);
  };

  const showWarningHandler = () => {
    setWarningModal(true);
    setIsOpen(false);
  };

  const warningValidation = () => {
    let status = true;
    let error = {};
    if (!warningField.heading) {
      error["heading"] = "Warning heading is mandatory";
      status = false;
    }
    if (!warningField.subject) {
      error["subject"] = "Warning subject is mandatory";
      status = false;
    }
    if (!warningField.warning) {
      error["warning"] = "Warning  is mandatory";
      status = false;
    }
    setError(error);
    return status;
  };

  const deductionValidation = () => {
    let status = true;
    if (!deductionValue) {
      setDeductionError("Please enter amount");
      status = false;
    }
    return status;
  };

  // Send warning handler
  const sendWarningHandler = async () => {
    if (warningValidation()) {
      try {
        const data = {
          consultantId: consultantId,
          subject: warningField.subject || "",
          heading: warningField.heading || "",
          warning: warningField.warning || "",
        };
        buttonLoader(true);
        const res = await sendWarningApi(data);
        if (res.data.code === 200) {
          toastMessage(res.data.message, "success", "sendWarning");
          setWarningModal(false);
          setWarningField({});
          setError({});
        } else {
          toastMessage(res.data.message, "error", "sendWarning");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        buttonLoader(false);
      }
    }
  };

  // handle all hooks
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // handle all function

  // const blockUserFunction = () => {
  //   setBlockUserModel(true)
  // }

  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  const closeModel = () => {
    setStatusModal(false);
    setStatusValue("");
    setStatusId("");
  };

  const getSelectedConsultantDetailHandler = async (userId) => {
    try {
      showLoader();
      const sendData = {
        consultantId: consultantId,
      };
      const { data } = await getSelectedConsultantDetail(sendData);
      if (data.code === 200) {
        setConsultantDetail(data?.result);
        // setConsultantEducationDetail(data.result.education);
        // scrollToUp();
      } else {
        setConsultantDetail("");
        toastMessage(data.message, "error", "consultantDetail");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Skill List
  const fetchCategoryHandler = async () => {
    try {
      setSkillList([]);
      showLoader();
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        setSkillList(data?.result?.categoryList || []);
        // setTotal(res?.data?.data?.pagination?.totalItems || 0)
      } else {
        setSkillList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  const consultantTypeHandler = (type) => {
    searchParam.set("type", type);
    setSearchParam(searchParam);
  };

  // Section tab change (Consultant Management vs Consultant Activity)
  const handleSectionTabChange = (event, newValue) => {
    setActiveSectionTab(newValue);
  };


  // useEffect(() => {
  //   fetchConsultantOrderList();
  // }, [activePage]); // Ensure data updates when page changes


  // Fetch Consultant order history (silent: no full-page loader, keep list until new data loads)
  const fetchConsultantOrderList = async (options = {}) => {
    const silent = options.silent === true;
    try {
      if (!silent) {
        setOrderList([]);
        showLoader();
      }
      const sendData = {
        page: activePage,
        limit: 10,
        consultantId: consultantId
      };
      if (debouncedSearchHistory) {
        sendData.search = debouncedSearchHistory;
      }
      if (historyStartDate) {
        sendData.startDate = historyStartDate;
      }
      if (historyEndDate) {
        sendData.endDate = historyEndDate;
      }
      if (historyGender) {
        sendData.gender = historyGender;
      }
      if (historyConsultationType) {
        sendData.consultationType = historyConsultationType;
      }
      if (historyUserProblem) {
        sendData.userProblem = historyUserProblem;
      }
      if (historyStatus) {
        sendData.status = historyStatus;
      }
      if (historyConsultationOrder) {
        sendData.consultationOrder = historyConsultationOrder;
      }
      if (historyUserTotalConsultations) {
        sendData.userTotalConsultations = historyUserTotalConsultations;
      }
      const { data } = await getConsultantOrderHistoryApi(sendData);

      if (data.code === 200) {
        // API returns result: { code, message, result: { list, total } } from service
        const payload = data?.result?.result ?? data?.result;
        setOrderList(payload?.list || []);
        setTotal(payload?.total ?? 0);
      } else {
        setOrderList([]);
        setTotal(0);
        toastMessage(data.message, "error", "orderList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      if (!silent) {
        hideLoader();
      }
    }
  };

  const fetchConsultantWaitlist = async () => {
    try {
      showLoader();
      const sendData = {
        consultantId: consultantId,
      }
      const { data } = await getConsultantWaitlist(sendData);

      if (data.code === 200) {
        setWaitList(data?.result?.list || []);
        setTotalWaitlist(data?.result?.total || 0);
      } else {
        setWaitList([]);
        setTotalWaitlist(0);
        toastMessage(data.message, "error", "orderList");
      }

    } catch (error) {
      console.log("error", error);
    }
    finally {
      hideLoader();
    }
  }

  // const walletDeductionHandler = async () => {
  //   if (deductionValidation()) {
  //     try {
  //       const data = {
  //         consultantId: consultantId,
  //         amount: deductionValue,
  //       };
  //       buttonLoader(true);
  //       let res;
  //       if (AddDeductState == 0) {
  //         res = await fetchWalletDeductionApi(data);
  //       } else {
  //         res = await fetchWalletAdditionApi(data);
  //       }
  //       if (res.data.code === 200) {
  //         toastMessage(res.data.message, "success", AddDeductState == 0 ? "deductionAmount" : "refundedAmount");
  //         setDeductionModal(false);
  //         setDeducationValue("");
  //         setDeductionError("");
  //         setAddDeductState(0);
  //       } else {
  //         toastMessage(res.data.message, "error", AddDeductState == 0 ? "deductionAmount" : 'refundedAmount');
  //       }
  //     } catch (e) {
  //       console.log("Error:", e.message);
  //     } finally {
  //       buttonLoader(false);
  //     }
  //   }
  // };

  const executeWalletDeduction = async () => {
    if (deductionValidation()) {
      try {
        const data = {
          consultantId: consultantId,
          amount: Number(deductionValue),
        };

        buttonLoader(true);
        let res;

        if (AddDeductState == 0) {
          // Deduction
          res = await fetchWalletDeductionApi(data);
        } else {
          // Addition
          res = await fetchWalletAdditionApi(data);
        }

        if (res.data.code === 200) {
          toastMessage(
            res.data.message,
            "success",
            AddDeductState == 0 ? "deductionAmount" : "refundedAmount"
          );
          setDeductionModal(false);
          setDeducationValue("");
          setDeductionError("");
          setAddDeductState(0);
          // Optionally refresh wallet info here
        } else {
          toastMessage(
            res.data.message,
            "error",
            AddDeductState == 0 ? "deductionAmount" : "refundedAmount"
          );
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        buttonLoader(false);
      }
    }
  };

  const walletDeductionHandler = () => {
    executeWalletDeduction();
  };

  const greenTickHandler = async () => {
    try {
      buttonLoader(true);
      const res = await markGreenTickApi({
        consultantId: consultantId,
        status: !consultantGreenTick,
      });
      if (res.data.code === 200) {
        toastMessage(res.data.message, "success", "greenTick");
        getSelectedConsultantDetailHandler();
        setGreenTickModal(false);
        setConsultantGreenTick(null);
      } else {
        toastMessage(res?.data?.message, "error", "greenTick");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      buttonLoader(false);
    }
  };

  // Go Live Handler
  const goLiveHandler = async () => {
    try {
      buttonLoader(true);
      const res = await goLiveApi({
        consultantId: consultantId,
        status: !consultantGoLive,
      });
      if (res.data.code === 200) {
        toastMessage(res.data.message, "success", "greenTick");
        getSelectedConsultantDetailHandler();
        setGoLiveModal(false);
        setConsultantGoLive(null);
      } else {
        toastMessage(res?.data?.message, "error", "greenTick");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      buttonLoader(false);
    }
  };

  // High Priority Handler
  const highPriorityHandler = async () => {
    try {
      buttonLoader(true);
      const res = await updateHighPriorityStatusApi({
        consultantId: consultantId,
        status: !consultantHighPriority,
      });
      if (res.data.code === 200) {
        toastMessage(res.data.message, "success", "highPriority");
        getSelectedConsultantDetailHandler();
        setHighPriorityModal(false);
        setConsultantHighPriority(null);
      } else {
        toastMessage(res?.data?.message, "error", "highPriority");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      buttonLoader(false);
    }
  };

  // Can End The Call Handler
  const canEndTheCallHandler = async () => {
    try {
      buttonLoader(true);
      const res = await updateCanEndTheCallStatusApi({
        consultantId: consultantId,
        status: !consultantCanEndTheCall,
      });
      if (res.data.code === 200) {
        toastMessage(res.data.message, "success", "canEndTheCall");
        getSelectedConsultantDetailHandler();
        setCanEndTheCallModal(false);
        setConsultantCanEndTheCall(null);
      } else {
        toastMessage(res?.data?.message, "error", "canEndTheCall");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      buttonLoader(false);
    }
  };

  // Bank Details Handlers
  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBankImageChange = (e, imageType) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toastMessage('Please select a valid image file', 'error');
        return;
      }

      setBankImageFiles(prev => ({
        ...prev,
        [imageType]: file
      }));

      const reader = new FileReader();
      reader.onloadend = () => {
        setBankImagePreviews(prev => ({
          ...prev,
          [imageType]: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBankImagePreview = (imageUrl) => {
    window.open(imageUrl, '_blank');
  };

  // Fetch consultant bank details
  const fetchConsultantBankDetails = async () => {
    try {
      setIsLoadingBankDetails(true);
      const { data } = await getConsultantBankDetailsApi(consultantId);
      if (data.code === 200 && data?.result?.bankDetails) {
        // Bank details exist in result.bankDetails
        const bankDetails = data.result.bankDetails;
        setExistingBankDetails(bankDetails);
        // Fill form with existing bank details
        setBankFormData({
          accountNumber: bankDetails.accountNumber || "",
          bankName: bankDetails.bankName || "",
          ifsc: bankDetails.ifsc || "",
          bankHolderName: bankDetails.bankHolderName || "",
        });
        setBankImagePreviews({
          attachment: bankDetails.attachment || bankDetails.attachmentUrl || "",
        });
      } else {
        // No bank details found, show empty form for adding
        setExistingBankDetails(null);
        setBankFormData({
          accountNumber: "",
          bankName: "",
          ifsc: "",
          bankHolderName: "",
        });
        setBankImagePreviews({
          attachment: "",
        });
      }
    } catch (error) {
      console.log("error", error);
      // If error, show empty form for adding
      setExistingBankDetails(null);
      setBankFormData({
        accountNumber: "",
        bankName: "",
        ifsc: "",
        bankHolderName: "",
      });
      setBankImagePreviews({
        attachment: "",
      });
    } finally {
      setIsLoadingBankDetails(false);
    }
  };

  const handleAddBankDetails = async () => {
    try {
      bankButtonLoader(true);
      const formDataToSend = new FormData();

      formDataToSend.append("consultantId", consultantId);
      formDataToSend.append("requestType", "BANK");
      formDataToSend.append("accountNumber", bankFormData.accountNumber || "");
      formDataToSend.append("bankName", bankFormData.bankName || "");
      formDataToSend.append("ifsc", bankFormData.ifsc || "");
      formDataToSend.append("bankHolderName", bankFormData.bankHolderName || "");

      if (bankImageFiles.attachment) {
        formDataToSend.append("attachment", bankImageFiles.attachment);
      } else {
        formDataToSend.append("attachment", bankImagePreviews.attachment || "");
      }

      const res = await addConsultantBankDetailsApi(formDataToSend);

      if (res?.data?.code === 200) {
        toastMessage(
          res?.data?.message || "Bank details added successfully",
          "success",
          "addBankDetails"
        );
        setBankDetailsModal(false);
        getSelectedConsultantDetailHandler();
        setBankFormData({});
        setBankImageFiles({});
        setBankImagePreviews({});
        setExistingBankDetails(null);
      } else {
        toastMessage(
          res?.data?.message || "Failed to add bank details",
          "error",
          "addBankDetails"
        );
      }
    } catch (e) {
      console.log(e.message);
      toastMessage(
        "An error occurred while adding bank details",
        "error",
        "addBankDetails"
      );
    } finally {
      bankButtonLoader(false);
    }
  };

  // PAN Card Handlers
  const handlePanInputChange = (e) => {
    const { name, value } = e.target;
    setPanFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePanImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toastMessage('Please select a valid image file', 'error');
        return;
      }

      setPanImageFile(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPanImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchConsultantPanDetails = async () => {
    try {
      setIsLoadingPanDetails(true);
      const { data } = await getConsultantBankDetailsApi(consultantId);
      if (data.code === 200 && data?.result?.panDetails) {
        const panDetails = data.result.panDetails;
        setExistingPanDetails(panDetails);
        setPanFormData({
          panNumber: panDetails.panNumber || "",
        });
        setPanImagePreview(
          panDetails.panImage || panDetails.pancardImage || panDetails.panImageUrl || ""
        );
      } else {
        setExistingPanDetails(null);
        setPanFormData({
          panNumber: "",
        });
        setPanImagePreview("");
      }
    } catch (error) {
      console.log("error", error);
      setExistingPanDetails(null);
      setPanFormData({
        panNumber: "",
      });
      setPanImagePreview("");
    } finally {
      setIsLoadingPanDetails(false);
    }
  };

  const handleAddPanDetails = async () => {
    try {
      panButtonLoader(true);
      const formDataToSend = new FormData();

      formDataToSend.append("consultantId", consultantId);
      formDataToSend.append("requestType", "PANCARD");
      formDataToSend.append("panNumber", panFormData.panNumber || "");

      if (panImageFile) {
        formDataToSend.append("panImage", panImageFile);
      } else {
        formDataToSend.append("panImage", panImagePreview || "");
      }

      const res = await addConsultantBankDetailsApi(formDataToSend);

      if (res?.data?.code === 200) {
        toastMessage(
          res?.data?.message || "PAN card details saved successfully",
          "success",
          "addPanDetails"
        );
        setPanCardModal(false);
        getSelectedConsultantDetailHandler();
        setPanFormData({});
        setPanImageFile(null);
        setPanImagePreview("");
        setExistingPanDetails(null);
      } else {
        toastMessage(
          res?.data?.message || "Failed to save PAN card details",
          "error",
          "addPanDetails"
        );
      }
    } catch (e) {
      console.log(e.message);
      toastMessage(
        "An error occurred while saving PAN card details",
        "error",
        "addPanDetails"
      );
    } finally {
      panButtonLoader(false);
    }
  };

  // Review handlers
  const handleReviewInputChange = (e) => {
    const { name, value } = e.target;
    setReviewFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field
    if (reviewError[name]) {
      setReviewError(prev => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  const handleReviewImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toastMessage('Please select a valid image file', 'error');
        return;
      }

      setReviewUserImage(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setReviewUserImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const validateReviewForm = () => {
    let isValid = true;
    const errors = {};

    if (!reviewFormData.review || reviewFormData.review.trim() === "") {
      errors.review = "Review is required";
      isValid = false;
    }

    if (!reviewFormData.rating || reviewFormData.rating < 1 || reviewFormData.rating > 5) {
      errors.rating = "Rating must be between 1 and 5";
      isValid = false;
    }

    if (reviewFormData.customDate && !reviewFormData.customTime) {
      // If date is provided, time is optional but can be validated if needed
    }

    setReviewError(errors);
    return isValid;
  };

  const handleAddReview = async () => {
    if (!validateReviewForm()) {
      return;
    }

    try {
      reviewButtonLoader(true);
      const formDataToSend = new FormData();

      formDataToSend.append("consultantId", consultantId);
      formDataToSend.append("review", reviewFormData.review);
      formDataToSend.append("rating", reviewFormData.rating);
      formDataToSend.append("userName", reviewFormData.userName || "");
      formDataToSend.append("customDate", reviewFormData.customDate || "");
      formDataToSend.append("customTime", reviewFormData.customTime || "");
      formDataToSend.append("ratingType", reviewFormData.ratingType || "chat");
      formDataToSend.append("reply", reviewFormData.reply || "");

      if (reviewUserImage) {
        formDataToSend.append("userImage", reviewUserImage);
      }

      const res = await addReviewByAdminApi(formDataToSend);

      if (res?.data?.code === 200) {
        toastMessage(
          res?.data?.message || "Review added successfully",
          "success",
          "addReview"
        );
        setReviewModal(false);
        setReviewFormData({
          review: "",
          rating: 5,
          userName: "",
          customDate: "",
          customTime: "",
          ratingType: "chat",
          reply: ""
        });
        setReviewUserImage(null);
        setReviewUserImagePreview("");
        setReviewError({});
        // Optionally refresh consultant details
        getSelectedConsultantDetailHandler();
      } else {
        toastMessage(
          res?.data?.message || "Failed to add review",
          "error",
          "addReview"
        );
      }
    } catch (e) {
      console.log(e.message);
      toastMessage(
        "An error occurred while adding review",
        "error",
        "addReview"
      );
    } finally {
      reviewButtonLoader(false);
    }
  };

  useEffect(() => {
    if (consultantId) {
      getSelectedConsultantDetailHandler(consultantId);
    }
  }, [consultantId]);

  useEffect(() => {
    fetchCategoryHandler();
  }, []);


  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    if (type === "consultant") {
      fetchConsultantOrderList();
    }
    fetchConsultantWaitlist();
  }, [searchParam, debouncedSearchHistory, historyStartDate, historyEndDate, historyGender, historyConsultationType, historyUserProblem, historyStatus, historyConsultationOrder, historyUserTotalConsultations]);

  const handleMediaDownload = (url) => {
    // console.log("ok");
    window.open(url);
  };
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      navigate(-1);
    } else {
      navigate("/default-route"); // Fallback route
    }
  };

  // Part-I: Profile Details - Left column (Personal/Contact)
  const profilePart1Left = [
    { label: "Name", value: consultantDetail?.name || consultantDetail?.accountName || consultantDetail?.details?.name || "---" },
    { label: "User Name", value: consultantDetail?.accountName || consultantDetail?.userName || "---" },
    { label: "Name (English)", value: consultantDetail?.names?.en || consultantDetail?.accountName || "---" },
    { label: "Name (Hindi)", value: consultantDetail?.names?.hi || "---" },
    { label: "Name (Kannada)", value: consultantDetail?.names?.kn || "---" },
    { label: "Gender", value: (consultantDetail?.gender || consultantDetail?.details?.gender) ? CapitalizeFirstWord(consultantDetail?.gender || consultantDetail?.details?.gender) : "---" },
    {
      label: "Mobile",
      value: (consultantDetail?.mobile || consultantDetail?.details?.phone) ? (
        <a href={`tel:${consultantDetail?.countryCode || consultantDetail?.details?.phonePrefix || ""}${consultantDetail?.mobile || consultantDetail?.details?.phone}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
          {`${consultantDetail?.countryCode || consultantDetail?.details?.phonePrefix || ""}${consultantDetail?.mobile || consultantDetail?.details?.phone}`}
        </a>
      ) : "---"
    },
    {
      label: "Sec. Mobile",
      value: consultantDetail?.secondaryMobile ? (
        <a href={`tel:${consultantDetail?.secondaryMobileCountryCode || ""}${consultantDetail?.secondaryMobile}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
          {`${consultantDetail?.secondaryMobileCountryCode || ""}-${consultantDetail?.secondaryMobile}`}
        </a>
      ) : "---"
    },
    { label: "E-mail Id", value: consultantDetail?.email || "---" },
    {
      label: "Address",
      value: (
        <div
          style={{
            maxWidth: "200px",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal"
          }}
        >
          {consultantDetail?.address || "---"}
        </div>
      )
    },
    { label: "City", value: consultantDetail?.city || "---" },
    { label: "State", value: consultantDetail?.state || "---" },
    { label: "Pincode", value: consultantDetail?.pincode || "---" },
    {
      label: "Education",
      value: (() => {
        const ed = consultantDetail?.highestQualification ?? consultantDetail?.qualification;
        if (ed == null || ed === "") return "---";
        if (Array.isArray(ed)) return ed.join(", ");
        return String(ed);
      })(),
    },
    { label: "Price", value: consultantDetail?.price?.default || consultantDetail?.price || "---" },
    { label: "PrivateCallonlive Price", value: consultantDetail?.price?.privateCallOnLive || "---" },
    { label: "Platform Share", value: consultantDetail?.price?.platformShare || "---" },
  ];

  // Consultant Activity profile: only Name, Contact, Per/min rate, Rating & reviews, Consultant score, Platform share, Expertise, Primary skills, Other skills
  const profileName = consultantDetail?.name || consultantDetail?.accountName || consultantDetail?.details?.name || "";
  const profilePhone = consultantDetail?.mobile || consultantDetail?.details?.phone || "";
  const profilePhonePrefix = consultantDetail?.countryCode || consultantDetail?.details?.phonePrefix || "";
  const activityProfileLeft = [
    { label: "Name", value: profileName || "---" },
    { label: "User Name", value: consultantDetail?.accountName || consultantDetail?.userName || "---" },
    { label: "ID", value: consultantDetail?.userId || "---" },
    { label: "Gender", value: (consultantDetail?.gender || consultantDetail?.details?.gender) ? CapitalizeFirstWord(consultantDetail?.gender || consultantDetail?.details?.gender) : "---" },
    {
      label: "Contact",
      value: (() => {
        const parts = [];
        if (profilePhone) {
          parts.push(
            <a key="m" href={`tel:${profilePhonePrefix}${profilePhone}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
              {`${profilePhonePrefix}${profilePhone}`}
            </a>
          );
        }
        if (consultantDetail?.secondaryMobile) {
          parts.push(
            <a key="s" href={`tel:${consultantDetail?.secondaryMobileCountryCode || ""}${consultantDetail?.secondaryMobile}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
              {`${consultantDetail?.secondaryMobileCountryCode || ""}-${consultantDetail?.secondaryMobile}`}
            </a>
          );
        }
        // if (consultantDetail?.email) parts.push(<span key="e">{consultantDetail.email}</span>);
        if (parts.length === 0) return "---";
        return (
          <span style={{ display: "flex", flexWrap: "wrap", gap: "4px 8px", alignItems: "center" }}>
            {parts.reduce((acc, p, i) => (i === 0 ? [p] : [...acc, <span key={`sep-${i}`} style={{ color: "#adb5bd", marginRight: "2px" }}>·</span>, p]), [])}
          </span>
        );
      })(),
    },
    { label: "Per/min rate", value: consultantDetail?.price?.default ?? consultantDetail?.price ?? "---" },
    { label: "Rating and reviews", value: consultantDetail?.ratingAverage?.average != null ? String(consultantDetail.ratingAverage.average) : "---" },
    { label: "Consultant score", value: consultantDetail?.score ?? "---" },
    { label: "Platform share", value: consultantDetail?.price?.platformShare ?? "---" },
  ];
  const activityProfileRight = [
    { label: "Expertise", value: formatDetailValue(consultantDetail?.expertise) },
    { label: "Primary Skills", value: formatDetailValue(consultantDetail?.primarySkills) },
    { label: "Other Skills", value: formatDetailValue(consultantDetail?.otherSkills) },
  ];

  // Part-I: Profile Details - Right column (Additional Profile)
  const bioText = consultantDetail?.bio || consultantDetail?.details?.aboutMe || "";
  const profilePart1Right = [
    {
      label: "About me",
      value: !bioText ? "---" : (
        isMobile ? <div style={{ display: "flex", flexDirection: "column", gap: "4px", maxWidth: "200px" }}>
          <span
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordBreak: "break-word"
            }}
            title={bioText}
          >
            {bioText}
          </span>

          <span
            style={{
              color: "#FF8989",
              cursor: "pointer",
              textDecoration: "underline",
              fontSize: "13px",
              fontWeight: 500
            }}
            onClick={() => setAboutMeModal(true)}
          >
            Read more
          </span>
        </div> : <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "200px", display: "inline-block" }} title={bioText}>
            {bioText.split("\n")[0]?.substring(0, 80) || bioText.substring(0, 80)}
            {(bioText.length > 80 || bioText.includes("\n")) && "..."}
          </span>
          <span
            style={{ color: "#FF8989", cursor: "pointer", textDecoration: "underline", fontSize: "13px", fontWeight: 500 }}
            onClick={() => setAboutMeModal(true)}
          >
            Read me
          </span>
        </div>
      )
    },
    { label: "Favourite Song", value: consultantDetail?.details?.FavSong || "---" },
    { label: "Movie Genre", value: consultantDetail?.details?.Movie || "---" },
    { label: "Zodiac Sign", value: consultantDetail?.details?.zodiac || "---" },
    { label: "Hobbies", value: Array.isArray(consultantDetail?.details?.Hobbies) ? consultantDetail?.details?.Hobbies.join(", ") : (consultantDetail?.details?.Hobbies || "---") },
    { label: "Place of Birth", value: consultantDetail?.details?.PlaceOfBirth || "---" },
    { label: "Currently living in", value: consultantDetail?.city || consultantDetail?.address || "---" },
    { label: "Expertise", value: formatDetailValue(consultantDetail?.expertise) },
    { label: "Primary Skills", value: formatDetailValue(consultantDetail?.primarySkills) },
    { label: "Other Skills", value: formatDetailValue(consultantDetail?.otherSkills) },
    { label: "Certification", value: consultantDetail?.certificate?.length > 0 ? "Available" : "Not Available" },
    { label: "Rating", value: consultantDetail?.ratingAverage?.average || "---" },
  ];

  // Legacy profileData for ResponsiveProfileSection (when not from=management)
  const profileData = [
    profilePart1Left.slice(0, 7),
    [...profilePart1Left.slice(7), ...profilePart1Right.slice(0, 3)],
    profilePart1Right.slice(3, 8),
    profilePart1Right.slice(8),
  ];


  const headerActions = [
    {
      label: "Edit Consultant V1",
      onClick: () => navigate(`/consultant-management/edit-v1/${consultantId}`),
      className: "btn_size"
    },
    {
      label: "Warning",
      onClick: showWarningHandler,
      className: "btn_size"
    },
    {
      label: "Bank Details",
      onClick: () => {
        setBankDetailsModal(true);
        fetchConsultantBankDetails();
      },
      className: "btn_size"
    },
    {
      label: "PAN Card",
      onClick: () => {
        setPanCardModal(true);
        fetchConsultantPanDetails();
      },
      className: "btn_size"
    },
    {
      label: "Wallet Deduction",
      onClick: () => {
        setDeductionError("");
        setDeducationValue("");
        setAddDeductState(0);
        setDeductionModal(true);
      },
      className: "btn_size"
    },
    {
      label: "Wallet Refund",
      onClick: () => {
        setDeductionError("");
        setDeducationValue("");
        setAddDeductState(1);
        setDeductionModal(true);
      },
      className: "btn_size"
    },
    {
      label: "Waitlist",
      onClick: () => setWaitlistModal(true),
      className: "btn_size"
    },
    {
      label: "Add Review",
      onClick: () => {
        setReviewModal(true);
        setReviewFormData({
          review: "",
          rating: 5,
          userName: "",
          customDate: "",
          customTime: "",
          ratingType: "chat",
          reply: ""
        });
        setReviewUserImage(null);
        setReviewUserImagePreview("");
        setReviewError({});
      },
      className: "btn_size"
    },
    {
      label: "Check Performance",
      onClick: () => navigate(`/consultant-management/check-performance/${consultantId}/${consultantDetail?.name}`),
      className: "btn_size"
    },
    {
      label: "Upload Form 16",
      onClick: () => navigate(`/form-16A/${consultantId}`),
      className: "btn_size"
    },
    {
      label: "Shopify",
      onClick: () => navigate(`/shopify/${consultantId}`),
      className: "btn_size"
    },
    {
      label: "KPI",
      onClick: () => navigate(`/consultant-management/kpi/${consultantId}/${consultantDetail?.name || 'Consultant'}`),
      className: "btn_size"
    }
  ];

  // Normalize gallery & video media so that only image files show in Gallery,
  // and video files (e.g. .mp4) are treated as Video section content.
  const rawGallery = Array.isArray(consultantDetail?.gallery)
    ? consultantDetail.gallery
    : (consultantDetail?.gallery ? [consultantDetail.gallery] : []);

  const getMediaUrl = (item) =>
    typeof item === "string" ? item : item?.url || "";

  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg", ".bmp", ".avif"];
  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv"];

  const imageGallery = rawGallery.filter((item) => {
    const url = getMediaUrl(item).toLowerCase();
    if (!url) return false;
    return imageExtensions.some((ext) => url.endsWith(ext));
  });

  const videoFromGallery = rawGallery.find((item) => {
    const url = getMediaUrl(item).toLowerCase();
    if (!url) return false;
    return videoExtensions.some((ext) => url.endsWith(ext));
  });

  const derivedVideoUrl =
    consultantDetail?.Video ||
    (videoFromGallery ? getMediaUrl(videoFromGallery) : "");

  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <ResponsiveDetailPage
            title="Consultant Management"
            onBack={handleBack}
            actions={activeSectionTab === 0 ? [] : headerActions}
            hideHeader={fromSource === "activity" || activeSectionTab === 1}
          >
            {/* Section Tabs: when from=activity show only Consultant Activity tab; when from=management hide tabs; else show both */}
            {fromSource !== "management" && (
              <Box sx={{ width: "100%", marginBottom: "20px" }}>
                <CustomTabs
                  value={fromSource === "activity" ? 0 : activeSectionTab}
                  onChange={fromSource === "activity" ? undefined : handleSectionTabChange}
                  aria-label="consultant detail sections"
                >
                  {fromSource === "activity" ? (
                    <CustomTab label="Consultant Activity" />
                  ) : (
                    <>
                      <CustomTab label="Consultant Management" />
                      <CustomTab label="Consultant Activity" />
                    </>
                  )}
                </CustomTabs>
              </Box>
            )}

            {/* Section A - Consultant Management - hidden when from=activity (only Activity tab in that case) */}
            {(activeSectionTab === 0 || fromSource === "management") && fromSource !== "activity" && (
              <>
                {fromSource === "management" ? (
                  <>
                    {/* Part-I: Profile Details - same component as Consultant Activity */}
                    <ConsultantProfileSection
                      leftData={profilePart1Left}
                      rightData={profilePart1Right}
                      className="consultant-profile-panel"
                      style={{ background: "transparent", boxShadow: "none" }}
                    />

                    {/* Part-II: Assets */}

                    <ConsultantOnlineSchedule />
                    <DashboardAnalytics />
                    <ConsultantOnlineTime />


                    {/* Part-IV: Editing Part */}
                    <div className="user_detail_container mb-4">
                      <h5 className="mb-3">Part-IV: Editing Part</h5>
                      <div className="d-flex flex-wrap gap-2 mb-3">
                        {headerActions.map((action, idx) => (
                          <button key={idx} className={`btn btn-sm ${action.className || "btn-outline-secondary"}`} onClick={action.onClick}>
                            {action.label}
                          </button>
                        ))}
                      </div>

                    </div>
                    <div className="user_detail_container mb-4">
                      <h5 className="mb-3">Switch Status</h5><div className="consultant-switch-container">

                        <div className="switch-item">
                          <label>Green Tick</label>
                          <Switch checked={consultantDetail?.greenTick} onChange={() => { setConsultantGreenTick(consultantDetail?.greenTick); setGreenTickModal(true); }} />
                        </div>
                        <div className="switch-item">
                          <label>Go Live</label>
                          <Switch checked={consultantDetail?.goLive} onChange={() => { setConsultantGoLive(consultantDetail?.goLive); setGoLiveModal(true); }} />
                        </div>
                        <div className="switch-item">
                          <label>High Priority</label>
                          <Switch checked={consultantDetail?.highPriority} onChange={() => { setConsultantHighPriority(consultantDetail?.highPriority); setHighPriorityModal(true); }} />
                        </div>
                        <div className="switch-item">
                          <label>Cannot End The Call</label>
                          <Switch checked={consultantDetail?.sessionsStatus?.canEndTheCall} onChange={() => { setConsultantCanEndTheCall(consultantDetail?.sessionsStatus?.canEndTheCall); setCanEndTheCallModal(true); }} />
                        </div>
                        <div className="switch-item">
                          <label>Profile Activate/Deactivate</label>
                          <Switch checked={consultantDetail?.status} onChange={() => statusUpdateHandler(consultantId, !consultantDetail?.status)} />
                        </div>
                      </div></div>

                    {/* Gallery & Media Section: 3 rows inside one bordered card - override global .user_detail_container height */}
                    <div
                      className="user_detail_container mb-4"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        border: "1px solid #e9ecef",
                        borderRadius: "12px",
                        padding: "20px",
                        backgroundColor: "#fff",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                        width: "100%",
                        minWidth: 0,
                        overflow: "visible",
                        boxSizing: "border-box",
                        justifyContent: "flex-start",
                        height: "auto",
                        minHeight: "auto",
                        alignItems: "stretch",
                      }}
                    >
                      <h5 className="mb-0" style={{ color: "#333" }}>Gallery & Media</h5>

                      {/* Row 1: Profile Photo only */}
                      <div style={{ width: "100%", minWidth: 0, borderBottom: "1px solid #e9ecef", paddingBottom: "20px" }}>
                        <h6 className="mb-2" style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>Profile Photo</h6>
                        {(consultantDetail?.profileImage || consultantDetail?.image) ? (
                          <div
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "8px",
                              overflow: "hidden",
                              border: "1px solid #e9ecef",
                              cursor: "pointer",
                              flexShrink: 0,
                            }}
                            onClick={() => handleMediaDownload(consultantDetail?.profileImage || consultantDetail?.image)}
                          >
                            <img
                              src={consultantDetail?.profileImage || consultantDetail?.image}
                              alt="Profile"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          </div>
                        ) : (
                          <p className="text-muted mb-0">No profile photo.</p>
                        )}
                      </div>

                      {/* Row 2: Gallery only - scroll inside card */}
                      <div style={{ width: "100%", minWidth: 0, borderBottom: "1px solid #e9ecef", paddingBottom: "20px" }}>
                        <h6 className="mb-2" style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>Gallery</h6>
                        {imageGallery.length > 0 ? (
                          <div style={{ display: "flex", flexDirection: "row", gap: "12px", flexWrap: "nowrap", overflowX: "auto", paddingBottom: "4px", minWidth: 0, maxWidth: "100%" }}>
                            {imageGallery.map((imgUrl, idx) => (
                              <div
                                key={idx}
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                  border: "1px solid #e9ecef",
                                  cursor: "pointer",
                                  flexShrink: 0,
                                }}
                                onClick={() => handleMediaDownload(getMediaUrl(imgUrl))}
                              >
                                <img
                                  src={getMediaUrl(imgUrl)}
                                  alt={`Gallery ${idx + 1}`}
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-muted mb-0">No gallery images available.</p>
                        )}
                      </div>

                      {/* Row 3: Video, Podcast, Client Stories - 3 boxes in one row, inside border */}
                      <div style={{ width: "100%", minWidth: 0 }}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: "16px",
                            alignItems: "stretch",
                            minWidth: 0,
                          }}
                        >
                          {/* Video */}
                          <div
                            style={{
                              border: "1px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "16px",
                              minHeight: "100px",
                              backgroundColor: "#fff",
                              display: "flex",
                              flexDirection: "column",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                            }}
                          >
                            <h6 className="mb-2" style={{ fontSize: "14px", fontWeight: 600, color: "#333", flexShrink: 0 }}>Video</h6>
                            <div style={{ flex: 1, minHeight: "44px" }}>
                              {derivedVideoUrl ? (
                                <a
                                  href={derivedVideoUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#FF8989", textDecoration: "underline", fontSize: "13px", wordBreak: "break-all" }}
                                >
                                  View Video
                                </a>
                              ) : (
                                <p className="text-muted mb-0" style={{ fontSize: "13px" }}>No video available.</p>
                              )}
                            </div>
                          </div>

                          {/* Podcast */}
                          <div
                            style={{
                              border: "1px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "16px",
                              minHeight: "100px",
                              backgroundColor: "#fff",
                              display: "flex",
                              flexDirection: "column",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                            }}
                          >
                            <h6 className="mb-2" style={{ fontSize: "14px", fontWeight: 600, color: "#333", flexShrink: 0 }}>Podcast</h6>
                            <div style={{ flex: 1, minHeight: "44px", overflowY: "auto", maxHeight: "200px" }}>
                              {(() => {
                                const podcast = consultantDetail?.podcast;
                                const urls = Array.isArray(podcast) ? podcast : (podcast ? [podcast] : []);
                                const validUrls = urls.filter(Boolean);
                                if (validUrls.length === 0) {
                                  return <p className="text-muted mb-0" style={{ fontSize: "13px" }}>No podcast available.</p>;
                                }
                                return (
                                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                    {validUrls.map((url, idx) => (
                                      <div key={idx} style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                                        <audio controls style={{ maxWidth: "100%", height: "32px", flex: "1 1 auto", minWidth: 0 }} src={typeof url === "string" ? url : url?.url || url} />
                                        <a href={typeof url === "string" ? url : url?.url || url} target="_blank" rel="noopener noreferrer" style={{ color: "#FF8989", fontSize: "12px", flexShrink: 0 }}>Open</a>
                                      </div>
                                    ))}
                                  </div>
                                );
                              })()}
                            </div>
                          </div>

                          {/* Client Stories */}
                          <div
                            style={{
                              border: "1px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "16px",
                              minHeight: "100px",
                              backgroundColor: "#fff",
                              display: "flex",
                              flexDirection: "column",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                            }}
                          >
                            <h6 className="mb-2" style={{ fontSize: "14px", fontWeight: 600, color: "#333", flexShrink: 0 }}>Client Stories</h6>
                            <div style={{ flex: 1, minHeight: "44px", overflowY: "auto", maxHeight: "200px" }}>
                              {consultantDetail?.clientStories && Array.isArray(consultantDetail.clientStories) && consultantDetail.clientStories.length > 0 ? (
                                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                  {consultantDetail.clientStories.map((story, idx) => (
                                    <div key={idx} style={{ border: "1px solid #eee", borderRadius: "6px", padding: "8px", backgroundColor: "#fafafa" }}>
                                      {story?.image && (
                                        <div
                                          style={{ width: "100%", maxWidth: "120px", aspectRatio: "1", borderRadius: "6px", overflow: "hidden", marginBottom: "6px", cursor: "pointer" }}
                                          onClick={() => handleMediaDownload(story.image)}
                                        >
                                          <img src={story.image} alt={`Story ${idx + 1}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                        </div>
                                      )}
                                      {story?.audio && (
                                        <audio controls style={{ width: "100%", height: "28px" }} src={story.audio} />
                                      )}
                                      {!story?.image && !story?.audio && <span className="text-muted" style={{ fontSize: "13px" }}>—</span>}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-muted mb-0" style={{ fontSize: "13px" }}>No client stories available.</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <ResponsiveProfileSection profileImage={consultantDetail?.profileImage || profile} profileData={profileData} />
                    <div className="consultant-switch-container mb-4">
                      <div className="switch-item">
                        <label>Green Tick</label>
                        <Switch checked={consultantDetail?.greenTick} onChange={() => { setConsultantGreenTick(consultantDetail?.greenTick); setGreenTickModal(true); }} />
                      </div>
                      <div className="switch-item">
                        <label>Go Live</label>
                        <Switch checked={consultantDetail?.goLive} onChange={() => { setConsultantGoLive(consultantDetail?.goLive); setGoLiveModal(true); }} />
                      </div>
                      <div className="switch-item">
                        <label>High Priority</label>
                        <Switch checked={consultantDetail?.highPriority} onChange={() => { setConsultantHighPriority(consultantDetail?.highPriority); setHighPriorityModal(true); }} />
                      </div>
                      <div className="switch-item">
                        <label>Cannot End The Call</label>
                        <Switch checked={consultantDetail?.sessionsStatus?.canEndTheCall} onChange={() => { setConsultantCanEndTheCall(consultantDetail?.sessionsStatus?.canEndTheCall); setCanEndTheCallModal(true); }} />
                      </div>
                    </div>
                    {consultantDetail?.certificate?.length > 0 && (
                      <div className="row mb-4">
                        <div className="col-12">
                          <div className="user_detail_container">
                            <h5 className="mb-3">Certification</h5>
                            <div className="certification-container">
                              <img src={consultantPerformance} alt="Consultant performance" className="certification-image" onClick={() => handleMediaDownload(consultantDetail.certificate[0])} />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}

            {/* Section B - Consultant Activity - shown when tab is Activity or when from=activity */}
            {(activeSectionTab === 1 || fromSource === "activity") && fromSource !== "management" && (
              <>
                {/* Profile - Consultant Activity: only name, contact, per/min rate, rating & reviews, consultant score, platform share, expertise, primary/other skills */}
                <ConsultantProfileSection
                  leftData={activityProfileLeft}
                  rightData={activityProfileRight}
                  compact
                  className="consultant-profile-panel"
                  style={{
                    border: "1px solid #e9ecef",
                    borderRadius: "12px",
                    padding: "16px 20px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginBottom: "20px",
                    minHeight: "300px",
                    overflow: "hidden",
                  }}
                />

                {/* Switches for live/priority status - clear section spacing */}
                <div className="consultant-switch-container mb-4" style={{ clear: "both", marginTop: "16px", marginBottom: "32px" }}>
                  <div className="switch-item">
                    <label>Green Tick</label>
                    <Switch
                      checked={consultantDetail?.greenTick}
                      onChange={() => {
                        setConsultantGreenTick(consultantDetail?.greenTick);
                        setGreenTickModal(true);
                      }}
                    />
                  </div>
                  <div className="switch-item">
                    <label>Go Live</label>
                    <Switch
                      checked={consultantDetail?.goLive}
                      onChange={() => {
                        setConsultantGoLive(consultantDetail?.goLive);
                        setGoLiveModal(true);
                      }}
                    />
                  </div>
                  <div className="switch-item">
                    <label>High Priority</label>
                    <Switch
                      checked={consultantDetail?.highPriority}
                      onChange={() => {
                        setConsultantHighPriority(consultantDetail?.highPriority);
                        setHighPriorityModal(true);
                      }}
                    />
                  </div>
                  <div className="switch-item">
                    <label>Cannot End The Call</label>
                    <Switch
                      checked={consultantDetail?.sessionsStatus?.canEndTheCall}
                      onChange={() => {
                        setConsultantCanEndTheCall(consultantDetail?.sessionsStatus?.canEndTheCall);
                        setCanEndTheCallModal(true);
                      }}
                    />
                  </div>
                </div>

                {/* Dashboard Analytics - Performance Indicators (with time filter support) - clear section */}
                <div style={{ marginTop: "24px", marginBottom: "32px" }}>
                  <ConsultantOnlineSchedule />
                  <DashboardAnalytics />
                  <ConsultantOnlineTime />
                </div>

                <div className="tab_table w-500">
                  <div className="FilterBox FilterArea" style={{ flexDirection: "row", flexWrap: "wrap", gap: "15px", alignItems: "center" }}>
                    <div className="form-group search_lg_size userSearch" style={{ minWidth: "200px", flex: "1 1 auto" }}>
                      <input
                        type="search"
                        className={`form-control ${(type === "consultant" && searchHistory) || (type === "transaction" && searchTransaction) || (type === "reviews" && searchReviews) || (type === "queries" && searchQueries) ? "active" : ""}`}
                        placeholder={
                          type === "consultant"
                            ? "Search by User ID, User Name..."
                            : type === "transaction"
                              ? "Search by Amount, Purpose, User..."
                              : type === "queries"
                                ? "Search query by User ID, name, mobile..."
                                : "Search by User, Rating, Review..."
                        }
                        value={
                          type === "consultant"
                            ? searchHistory
                            : type === "transaction"
                              ? searchTransaction
                              : type === "queries" ? searchQueries : searchReviews
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          if (type === "consultant") setSearchHistory(val);
                          else if (type === "transaction") setSearchTransaction(val);
                          else if (type === "queries") setSearchQueries(val);
                          else setSearchReviews(val);
                        }}
                        style={{ "--color": "#FF8989" }}
                      />
                      <span className="user_search_icon">
                        <IoSearch />
                      </span>
                    </div>
                    {(type === "consultant" || type === "transaction" || type === "reviews") && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
                        {type === "consultant" && (
                          <>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>User Gender</label>
                              <select
                                className="form-control"
                                value={historyGender}
                                onChange={(e) => setHistoryGender(e.target.value)}
                                style={{ minWidth: "120px" }}
                              >
                                <option value="">All</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>Type of Consultation</label>
                              <select
                                className="form-control"
                                value={historyConsultationType}
                                onChange={(e) => setHistoryConsultationType(e.target.value)}
                                style={{ minWidth: "140px" }}
                              >
                                <option value="">All</option>
                                <option value="audio">Audio</option>
                                <option value="chat">Chat</option>
                                <option value="video">Video</option>
                              </select>
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>User's Problem</label>
                              <select
                                className="form-control"
                                value={historyUserProblem}
                                onChange={(e) => setHistoryUserProblem(e.target.value)}
                                style={{ minWidth: "140px" }}
                              >
                                <option value="">All</option>
                                <option value="Family">Family</option>
                                <option value="Finance">Finance</option>
                                <option value="Career">Career</option>
                                <option value="Marriage">Marriage</option>
                                <option value="Relationship">Relationship</option>
                                <option value="Health">Health</option>
                                <option value="Exam">Exam</option>
                                <option value="Depression">Depression</option>
                              </select>
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>Status</label>
                              <select
                                className="form-control"
                                value={historyStatus}
                                onChange={(e) => setHistoryStatus(e.target.value)}
                                style={{ minWidth: "120px" }}
                              >
                                <option value="">All</option>
                                <option value="completed">Completed</option>
                                <option value="canceled">Canceled</option>
                                <option value="missed">Missed</option>
                                <option value="progress">Progress</option>
                                <option value="waiting">Waiting</option>
                                <option value="blocked">Blocked</option>
                              </select>
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>Consultation</label>
                              <select
                                className="form-control"
                                value={historyConsultationOrder}
                                onChange={(e) => setHistoryConsultationOrder(e.target.value)}
                                style={{ minWidth: "110px" }}
                              >
                                <option value="">All</option>
                                <option value="1">1st</option>
                                <option value="2">2nd</option>
                                <option value="3">3rd</option>
                                <option value="repeat">Repeat (4+)</option>
                              </select>
                            </div>
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>User Total Consultations</label>
                              <select
                                className="form-control"
                                value={historyUserTotalConsultations}
                                onChange={(e) => setHistoryUserTotalConsultations(e.target.value)}
                                style={{ minWidth: "140px" }}
                              >
                                <option value="">All</option>
                                {Array.from({ length: 20 }, (_, i) => i + 1).map((n) => (
                                  <option key={n} value={String(n)}>{n}</option>
                                ))}
                              </select>
                            </div>
                          </>
                        )}
                        <div className="form-group" style={{ marginBottom: 0 }}>
                          <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>From Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={type === "consultant" ? historyStartDate : type === "transaction" ? transactionStartDate : type === "queries" ? queryStartDate : reviewStartDate}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (type === "consultant") setHistoryStartDate(val);
                              else if (type === "transaction") setTransactionStartDate(val);
                              else if (type === "queries") setQueryStartDate(val);
                              else setReviewStartDate(val);
                            }}
                            style={{ minWidth: "140px" }}
                          />
                        </div>
                        <div className="form-group" style={{ marginBottom: 0 }}>
                          <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>To Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={type === "consultant" ? historyEndDate : type === "transaction" ? transactionEndDate : type === "queries" ? queryEndDate : reviewEndDate}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (type === "consultant") setHistoryEndDate(val);
                              else if (type === "transaction") setTransactionEndDate(val);
                              else if (type === "queries") setQueryEndDate(val);
                              else setReviewEndDate(val);
                            }}
                            style={{ minWidth: "140px" }}
                          />
                        </div>
                        {((type === "consultant" && (historyStartDate || historyEndDate || historyGender || historyConsultationType || historyUserProblem || historyStatus || historyConsultationOrder || historyUserTotalConsultations)) || (type === "transaction" && (transactionStartDate || transactionEndDate)) || (type === "reviews" && (reviewStartDate || reviewEndDate)) || (type === "queries" && (queryStartDate || queryEndDate))) && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            style={{ alignSelf: "flex-end", marginBottom: "2px" }}
                            onClick={() => {
                              if (type === "consultant") {
                                setHistoryStartDate("");
                                setHistoryEndDate("");
                                setHistoryGender("");
                                setHistoryConsultationType("");
                                setHistoryUserProblem("");
                                setHistoryStatus("");
                                setHistoryConsultationOrder("");
                                setHistoryUserTotalConsultations("");
                              } else if (type === "transaction") {
                                setTransactionStartDate("");
                                setTransactionEndDate("");
                              } else if (type === "queries") {
                                setQueryStartDate("");
                                setQueryEndDate("");
                              } else {
                                setReviewStartDate("");
                                setReviewEndDate("");
                              }
                            }}
                          >
                            Clear
                          </button>
                        )}
                      </div>
                    )}
                    <ResponsiveTabs
                      value={type}
                      onChange={(e, section) => {
                        consultantTypeHandler(section);
                      }}
                      tabs={[
                        { value: "consultant", label: "Consultation History" },
                        { value: "transaction", label: "Transaction" },
                        { value: "reviews", label: "Reviews" },
                        { value: "queries", label: "Queries" }
                      ]}
                    />
                  </div>
                </div>

                {type === "consultant" && (
                  <div className="mt-3">
                    <ConsultantHistory
                      handlePageChange={handlePageChange}
                      orderList={orderList}
                      activePage={activePage}
                      total={total}
                      consultantId={consultantId}
                      onConsultationHistoryRefresh={() =>
                        fetchConsultantOrderList({ silent: true })
                      }
                    />
                  </div>
                )}
                {type === "transaction" && (
                  <div className="mt-3">
                    <ConsultantTransactionListing
                      consultantId={consultantId}
                      username={consultantDetail?.name}
                      search={debouncedSearchTransaction}
                      startDate={transactionStartDate}
                      endDate={transactionEndDate}
                    />
                  </div>
                )}
                {type === "reviews" && (
                  <div className="mt-3">
                    <ConsultantReviewsListing
                      consultantId={consultantId}
                      search={debouncedSearchReviews}
                      startDate={reviewStartDate}
                      endDate={reviewEndDate}
                    />
                  </div>
                )}
                {type === "queries" && (
                  <div className="mt-3">
                    <ConsultantQueriesListing
                      consultantId={consultantId}
                      search={debouncedSearchQueries}
                      startDate={queryStartDate}
                      endDate={queryEndDate}
                    />
                  </div>
                )}
              </>
            )}
          </ResponsiveDetailPage>
        </div>
      </div>
      {/* {statusModal && (
        <UserStatus
          show={statusModal}
          close={closeModel}
          setUserDetail={setUserDetail}
          setListing={''}
          status={statusValue}
          id={statusId}
        />
      )} */}
      {/* About me - Bio popup (no Yes/No footer - close via X only) */}
      <ModalBox
        status={aboutMeModal}
        onClose={() => setAboutMeModal(false)}
        title="About me"
        closeIcon
        size={"md"}
        custom
        noFooter
      >
        <div style={{ padding: "15px 0", whiteSpace: "pre-wrap", lineHeight: 1.6, color: "#333" }}>
          {bioText || "---"}
        </div>
      </ModalBox>

      <ModalBox
        status={warningModal}
        onClose={() => {
          setWarningModal(false);
          setWarningField({});
          setError({});
        }}
        title={"Warning"}
        closeIcon
        size={"sm"}
        custom
        customizedFooter={
          <div className="model_custom_footer">
            <button
              className="btn_size "
              ref={buttonref}
              onClick={sendWarningHandler}
            >
              Send
            </button>
          </div>
        }
      >
        <div>
          <div className="form-group mb-2">
            <Input
              type="text"
              name="heading"
              value={warningField.heading || ""}
              required
              onChange={(e) => {
                setWarningField({
                  ...warningField,
                  heading: e.target.value,
                });
              }}
              placeholder=" Heading"
              className={`form-control `}
              label={"Heading"}
              error={!warningField.heading && error.heading}
            // maxLength={30}
            />
            <Input
              type="text"
              name="subject"
              value={warningField.subject || ""}
              required
              onChange={(e) => {
                setWarningField({
                  ...warningField,
                  subject: e.target.value,
                });
              }}
              placeholder=" Subject"
              className={`form-control `}
              label={"Subject"}
              error={!warningField.subject && error.subject}
            // maxLength={30}
            />
            <TextArea
              type="text"
              name="title"
              value={warningField.warning || ""}
              required
              onChange={(e) => {
                setWarningField({
                  ...warningField,
                  warning: e.target.value,
                });
              }}
              placeholder="Warning"
              className={`form-control `}
              label={"Warning"}
              error={!warningField.warning && error.warning}
            />
          </div>
        </div>
      </ModalBox>

      {/* Addition & Deduction Wallet */}
      <ModalBox
        status={deductionModal}
        onClose={() => {
          setDeductionModal(false);
          setDeducationValue("");
          setDeductionError("");
        }}
        title={AddDeductState == 1 ? 'Walled Refund' : "Wallet Deduction"}
        closeIcon
        size={"sm"}
        custom
        customizedFooter={
          <div className="model_custom_footer">
            <button
              className="btn_size "
              ref={buttonref}
              onClick={walletDeductionHandler}
            >
              Yes
            </button>
          </div>
        }
      >
        <div>
          <div className="form-group mb-2">
            <Input
              type="text"
              name="heading"
              value={deductionValue || ""}
              required
              onChange={(e) => {
                setDeducationValue((e.target.value));
              }}
              placeholder="Amount"
              className={`form-control `}
              label={"Amount"}
              error={!deductionValue && deductionError}
            // maxLength={30}
            />
          </div>
        </div>
      </ModalBox>

      {/* Waitlist */}

      <WaitListModal
        status={WaitlistModal}
        onClose={() => {
          setWaitlistModal(false)
        }}
        title={"Waitlist"}
        description={waitList}
        closeIcon
        size={"sm"}
        custom
      >
        <div>
          <div className="form-group mb-2">

          </div>
        </div>
      </WaitListModal>

      <ModalBox
        status={greenTickMOdal}
        onClose={() => {
          setGreenTickModal(false);
          setConsultantGreenTick(null);
        }}
        title="Give Consultant Green Tick"
        description={
          consultantGreenTick
            ? "Do you want to remove green tick from this consultant"
            : "Do you want to give consultant green tick?"
        }
        action={greenTickHandler}
        ref={buttonref}
      />

      <ModalBox
        status={goLiveModal}
        onClose={() => {
          setGoLiveModal(false);
          setConsultantGoLive(null);
        }}
        title="Go Live"
        description={
          consultantGreenTick
            ? "Do you want to revoke consultant from go live?"
            : "Do you want to allow consultant go live?"
        }
        action={goLiveHandler}
        ref={buttonref}
      />

      <ModalBox
        status={highPriorityModal}
        onClose={() => {
          setHighPriorityModal(false);
          setConsultantHighPriority(null);
        }}
        title="High Priority Status"
        description={
          consultantHighPriority
            ? "Do you want to remove high priority status from this consultant?"
            : "Do you want to mark this consultant as high priority?"
        }
        action={highPriorityHandler}
        ref={buttonref}
      />

      <ModalBox
        status={canEndTheCallModal}
        onClose={() => {
          setCanEndTheCallModal(false);
          setConsultantCanEndTheCall(null);
        }}
        title="Cannot End The Call Status"
        description={
          consultantCanEndTheCall
            ? "Do you want to enable call ending for this consultant?"
            : "Do you want to disable call ending for this consultant?"
        }
        action={canEndTheCallHandler}
        ref={buttonref}
      />

      {/* Bank Details Modal */}
      <ModalBox
        status={bankDetailsModal}
        onClose={() => {
          setBankDetailsModal(false);
          setBankFormData({});
          setBankImageFiles({});
          setBankImagePreviews({});
          setExistingBankDetails(null);
        }}
        title="Add Bank Details"
        closeIcon
        size={"lg"}
        custom
        customizedFooter={
          <div className="model_custom_footer">
            <button
              className="btn_size mx-4"
              ref={bankButtonref}
              onClick={handleAddBankDetails}
              style={{ backgroundColor: '#1976d2', color: 'white' }}
              disabled={isLoadingBankDetails}
            >
              {isLoadingBankDetails ? "Loading..." : existingBankDetails ? "Update Bank Details" : "Add Bank Details"}
            </button>
          </div>
        }
      >
        {isLoadingBankDetails ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Loader />
            <p>Loading bank details...</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
            {/* Bank Details Form */}
            <div style={{ flex: 1, minWidth: 250 }}>
              {existingBankDetails ? (
                <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f0f0f0', borderRadius: '6px' }}>
                  <h6 style={{ color: '#1976d2', marginBottom: '10px' }}>Current Bank Details</h6>
                  <p style={{ marginBottom: '8px' }}><strong>Account Number:</strong> {existingBankDetails.accountNumber || "---"}</p>
                  <p style={{ marginBottom: '8px' }}><strong>Bank Name:</strong> {existingBankDetails.bankName || "---"}</p>
                  <p style={{ marginBottom: '8px' }}><strong>IFSC:</strong> {existingBankDetails.ifsc || "---"}</p>
                  <p style={{ marginBottom: '8px' }}><strong>Bank Holder Name:</strong> {existingBankDetails.bankHolderName || "---"}</p>
                  {(existingBankDetails.attachment || existingBankDetails.attachmentUrl) && (
                    <div style={{ marginTop: '10px' }}>
                      <strong>Attachment:</strong>
                      <img
                        src={existingBankDetails.attachment || existingBankDetails.attachmentUrl}
                        alt="Bank Attachment"
                        style={{
                          maxWidth: '200px',
                          height: 'auto',
                          borderRadius: 6,
                          border: '1px solid #eee',
                          marginTop: 8,
                          cursor: 'pointer',
                          display: 'block'
                        }}
                        onClick={() => handleBankImagePreview(existingBankDetails.attachment || existingBankDetails.attachmentUrl)}
                      />
                    </div>
                  )}
                  {/* <p style={{ color: '#666', marginTop: '10px', fontStyle: 'italic' }}>
                    Bank details already exist. To add new details, please contact support.
                  </p> */}
                </div>
              ) : null}
              <>
                  <h6>{existingBankDetails ? "Edit Bank Details" : "Add Bank Details"}</h6>
                  {/* Account Number */}
                  <div className="form-group mb-2 mt-4">
                    <Input
                      type="text"
                      name="accountNumber"
                      value={bankFormData.accountNumber || ""}
                      onChange={handleBankInputChange}
                      required
                      placeholder="Enter Account Number"
                      className={`form-control `}
                      label={"Account Number"}
                      maxLength={20}
                    />
                  </div>
                  {/* Bank Name */}
                  <div className="form-group mb-2">
                    <Input
                      type="text"
                      name="bankName"
                      value={bankFormData.bankName || ""}
                      onChange={handleBankInputChange}
                      required
                      placeholder="Enter Bank Name"
                      className={`form-control `}
                      label={"Bank Name"}
                      maxLength={20}
                    />
                  </div>
                  {/* IFSC */}
                  <div className="form-group mb-2">
                    <Input
                      type="text"
                      name="ifsc"
                      value={bankFormData.ifsc || ""}
                      onChange={handleBankInputChange}
                      required
                      placeholder="Enter IFSC"
                      className={`form-control `}
                      label={"IFSC"}
                      maxLength={20}
                    />
                  </div>
                  {/* Bank Holder Name */}
                  <div className="form-group mb-2">
                    <Input
                      type="text"
                      name="bankHolderName"
                      value={bankFormData.bankHolderName || ""}
                      onChange={handleBankInputChange}
                      required
                      placeholder="Enter Bank Holder Name"
                      className={`form-control `}
                      label={"Bank Holder Name"}
                      maxLength={20}
                    />
                  </div>
                  {/* Attachment Image */}
                  <div className="form-group mb-2">
                    <label className="my-1 text-dark" style={{ fontWeight: 500 }}>Bank Attachment</label>
                    <Input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleBankImageChange(e, 'attachment')}
                      className={`form-control `}
                      label={"Upload Bank Attachment"}
                    />
                    {bankImagePreviews.attachment && (
                      <img
                        src={bankImagePreviews.attachment}
                        alt="Bank Attachment Preview"
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                          borderRadius: 6,
                          border: '1px solid #eee',
                          marginTop: 8,
                          cursor: 'pointer',
                          transition: 'transform 0.2s ease'
                        }}
                        onClick={() => handleBankImagePreview(bankImagePreviews.attachment)}
                        onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                      />
                    )}
                  </div>
                </>
            </div>
          </div>
        )}
      </ModalBox>

      {/* PAN Card Modal */}
      <ModalBox
        status={panCardModal}
        onClose={() => {
          setPanCardModal(false);
          setPanFormData({});
          setPanImageFile(null);
          setPanImagePreview("");
          setExistingPanDetails(null);
        }}
        title="Add PAN Card"
        closeIcon
        size={"lg"}
        custom
        customizedFooter={
          <div className="model_custom_footer">
            <button
              className="btn_size mx-4"
              ref={panButtonref}
              onClick={handleAddPanDetails}
              style={{ backgroundColor: '#1976d2', color: 'white' }}
              disabled={isLoadingPanDetails}
            >
              {isLoadingPanDetails ? "Loading..." : existingPanDetails ? "Update PAN Card" : "Add PAN Card"}
            </button>
          </div>
        }
      >
        {isLoadingPanDetails ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Loader />
            <p>Loading PAN card details...</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
            <div style={{ flex: 1, minWidth: 250 }}>
              {existingPanDetails ? (
                <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f0f0f0', borderRadius: '6px' }}>
                  <h6 style={{ color: '#1976d2', marginBottom: '10px' }}>Current PAN Card Details</h6>
                  <p style={{ marginBottom: '8px' }}><strong>PAN Number:</strong> {existingPanDetails.panNumber || "---"}</p>
                  {(existingPanDetails.panImage || existingPanDetails.pancardImage || existingPanDetails.panImageUrl) && (
                    <div style={{ marginTop: '10px' }}>
                      <strong>PAN Image:</strong>
                      <img
                        src={existingPanDetails.panImage || existingPanDetails.pancardImage || existingPanDetails.panImageUrl}
                        alt="PAN Card"
                        style={{
                          maxWidth: '200px',
                          height: 'auto',
                          borderRadius: 6,
                          border: '1px solid #eee',
                          marginTop: 8,
                          cursor: 'pointer',
                          display: 'block'
                        }}
                        onClick={() => handleBankImagePreview(existingPanDetails.panImage || existingPanDetails.pancardImage || existingPanDetails.panImageUrl)}
                      />
                    </div>
                  )}
                </div>
              ) : null}
              <>
                <h6>{existingPanDetails ? "Edit PAN Card" : "Add PAN Card"}</h6>
                <div className="form-group mb-2 mt-4">
                  <Input
                    type="text"
                    name="panNumber"
                    value={panFormData.panNumber || ""}
                    onChange={handlePanInputChange}
                    required
                    placeholder="Enter PAN Number"
                    className={`form-control `}
                    label={"PAN Number"}
                    maxLength={10}
                  />
                </div>
                <div className="form-group mb-2">
                  <label className="my-1 text-dark" style={{ fontWeight: 500 }}>PAN Card Image</label>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={handlePanImageChange}
                    className={`form-control `}
                    label={"Upload PAN Card"}
                  />
                  {panImagePreview && (
                    <img
                      src={panImagePreview}
                      alt="PAN Card Preview"
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        borderRadius: 6,
                        border: '1px solid #eee',
                        marginTop: 8,
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease'
                      }}
                      onClick={() => handleBankImagePreview(panImagePreview)}
                      onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                      onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                    />
                  )}
                </div>
              </>
            </div>
          </div>
        )}
      </ModalBox>

      {/* Add Review Modal */}
      <ModalBox
        status={reviewModal}
        onClose={() => {
          setReviewModal(false);
          setReviewFormData({
            review: "",
            rating: 5,
            userName: "",
            customDate: "",
            customTime: "",
            ratingType: "chat",
            reply: ""
          });
          setReviewUserImage(null);
          setReviewUserImagePreview("");
          setReviewError({});
        }}
        title="Add Review"
        closeIcon
        size={"lg"}
        custom
        customizedFooter={
          <div className="model_custom_footer">
            <button
              className="btn_size mx-4"
              ref={reviewButtonref}
              onClick={handleAddReview}
              style={{ backgroundColor: '#1976d2', color: 'white' }}
            >
              Add Review
            </button>
          </div>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Review Text */}
          <div className="form-group">
            <TextArea
              name="review"
              value={reviewFormData.review}
              onChange={handleReviewInputChange}
              required
              placeholder="Enter review text"
              className={`form-control ${reviewError.review ? 'is-invalid' : ''}`}
              label={"Review *"}
              error={reviewError.review}
              rows={4}
            />
          </div>

          {/* Rating */}
          <div className="form-group">
            <label className="my-1 text-dark" style={{ fontWeight: 500 }}>
              Rating * (1-5)
            </label>
            <Input
              type="number"
              name="rating"
              value={reviewFormData.rating}
              onChange={handleReviewInputChange}
              required
              min="1"
              max="5"
              placeholder="Rating"
              className={`form-control ${reviewError.rating ? 'is-invalid' : ''}`}
              error={reviewError.rating}
            />
          </div>

          {/* User Name */}
          <div className="form-group">
            <Input
              type="text"
              name="userName"
              value={reviewFormData.userName}
              onChange={handleReviewInputChange}
              placeholder="User Name"
              className="form-control"
              label={"User Name"}
              maxLength={50}
            />
          </div>

          {/* Date and Time Row */}
          <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
            <div className="form-group" style={{ flex: 1, minWidth: '200px' }}>
              <Input
                type="date"
                name="customDate"
                value={reviewFormData.customDate}
                onChange={handleReviewInputChange}
                placeholder="Date"
                className="form-control"
                label={"Date (Optional)"}
              />
            </div>
            <div className="form-group" style={{ flex: 1, minWidth: '200px' }}>
              <Input
                type="time"
                name="customTime"
                value={reviewFormData.customTime}
                onChange={handleReviewInputChange}
                placeholder="Time"
                className="form-control"
                label={"Time (Optional)"}
              />
            </div>
          </div>

          {/* Rating Type */}
          <div className="form-group">
            <label className="my-1 text-dark" style={{ fontWeight: 500 }}>
              Rating Type
            </label>
            <select
              name="ratingType"
              value={reviewFormData.ratingType}
              onChange={handleReviewInputChange}
              className="form-control"
            >
              <option value="chat">Chat</option>
              <option value="call">Call</option>
            </select>
          </div>

          {/* User Image */}
          <div className="form-group">
            <label className="my-1 text-dark" style={{ fontWeight: 500 }}>
              User Image (Optional)
            </label>
            <Input
              type="file"
              accept="image/*"
              onChange={handleReviewImageChange}
              className="form-control"
            />
            {reviewUserImagePreview && (
              <img
                src={reviewUserImagePreview}
                alt="User Preview"
                style={{
                  maxWidth: '150px',
                  height: 'auto',
                  borderRadius: 6,
                  border: '1px solid #eee',
                  marginTop: 8
                }}
              />
            )}
          </div>

          {/* Consultant Reply */}
          <div className="form-group">
            <TextArea
              name="reply"
              value={reviewFormData.reply}
              onChange={handleReviewInputChange}
              placeholder="Consultant Reply (Optional)"
              className="form-control"
              label={"Consultant Reply (Optional)"}
              rows={3}
            />
            <small className="text-muted">
              This reply will be automatically added as if the consultant replied to this review.
            </small>
          </div>
        </div>
      </ModalBox>
    </>
  );
};
export default ConsultantDetail;
